import { lazy } from 'react';

import { InvoiceDeepLink } from '@/features/invoicing/InvoiceDeepLink';

export const InvoicesPage = lazy(() =>
  import('@/features/invoicing/InvoicesPage').then((module) => ({ default: module.InvoicesPage })),
);

export const PublicInvoicePage = lazy(() =>
  import('@/features/invoicing/PublicInvoicePage').then((module) => ({
    default: module.PublicInvoicePage,
  })),
);

/**
 * Screens beneath the invoices path.
 *
 * `:id` is where a link to an invoice points, and it is not a page of its own: it hands the invoice
 * to the invoices screen, which keeps the open invoice in its query string. It is imported directly
 * rather than lazily because it renders nothing, so a chunk request would only delay the redirect.
 */
export const BILLING_CHILD_ROUTES = {
  invoices: [{ path: ':id', element: InvoiceDeepLink }],
};
